// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3RO92","textWrapper":"styles_textWrapper__euKgz"};